/** Shared chooser section tones (Edit existing / org / EZOS / scratch). */

export type SetupChooserLane = 'existing' | 'ezos' | 'org' | 'scratch'

export type SetupOriginLane = 'ezos' | 'org' | 'scratch'

export type SectionTone = {
    accent: string
    iconBg: string
    iconColor: string
}

export const SECTION_TONES: Record<SetupChooserLane, SectionTone> = {
    existing: {
        accent: '#2E7D32',
        iconBg: '#E8F5E9',
        iconColor: '#2E7D32',
    },
    ezos: {
        accent: '#1565C0',
        iconBg: '#E3F2FD',
        iconColor: '#1565C0',
    },
    org: {
        accent: '#455A64',
        iconBg: '#ECEFF1',
        iconColor: '#455A64',
    },
    scratch: {
        accent: '#9E9E9E',
        iconBg: '#F5F5F5',
        iconColor: '#616161',
    },
}

export interface SetupOriginInfo {
    lane: SetupOriginLane
    /** Template / source name shown next to the icon. */
    label: string
}

/** Resolve origin for property-owned configs (chooser + selected bar). */
export function resolveSetupOrigin(option: {
    adoptedFromSource?: SetupOriginLane
    adoptedFromName?: string
}): SetupOriginInfo | null {
    const lane = option.adoptedFromSource
    if (!lane) return null
    if (lane === 'scratch') {
        return { lane, label: 'Scratch' }
    }
    if (option.adoptedFromName) {
        return { lane, label: option.adoptedFromName }
    }
    return {
        lane,
        label: lane === 'org' ? 'Org template' : 'EZOS template',
    }
}
